/** Temporary UI cohort for real provider consent and read tests.
 * Provider JWT checks, ownership, scopes and write approvals remain server-owned.
 * Remove the cohort when the normal public provider rollout is accepted.
 */
import { CONNECTION_VALIDATION_USER_ID } from "../../supabase/functions/_shared/connectionValidation";
export { CONNECTION_VALIDATION_USER_ID };

interface ConnectionIdentity {
  userId: string | null;
  ready: boolean;
  error: boolean;
}

export function isConnectionValidationAccount(identity: ConnectionIdentity): boolean {
  return identity.ready && !identity.error && identity.userId === CONNECTION_VALIDATION_USER_ID;
}
